(function () {
    'use strict';

    angular.module("imApp").factory("docCategoryLangService", ['$ihttp', function ($ihttp) {
        let service = {
            listLanguages: function (parms) {
                return $ihttp.post({
                    method: 3725,
                    parameters: parms || {}
                });
            },
            saveObj: function (list) {
                return $ihttp.post({
                    method: 3726,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
